import React__default from 'react';
import { createBasketInputId } from '@keepeek/commons';
import { TextField } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import KDialog from '../../../KDialog/index.js';
import { withSuspense } from '../../../withSuspense/index.js';

var BasketCreate = function (_a) {
    var className = _a.className, id = _a.id, open = _a.open, title = _a.title, _b = _a.setTitle, setTitle = _b === void 0 ? function (_title) { } : _b, close = _a.close, _c = _a.createBasket, createBasket = _c === void 0 ? function () { } : _c, loading = _a.loading;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(KDialog, { id: id, testId: "createBasketPopup", className: clsx(className, "BasketCreate", open && "BasketCreate-open"), open: open, actionLabel: t("components.action.create"), cancelLabel: t("components.action.cancel"), titleLabel: t("components.basket.create.title.label"), loading: loading, dialogContent: React__default.createElement(TextField
        // autoFocus
        , { 
            // autoFocus
            margin: "dense", id: createBasketInputId, "data-testid": "basketTitleField", label: t("components.basket.create.name.label"), type: "text", variant: "standard", value: title, onChange: function (_a) {
                var target = _a.target;
                return setTitle(target.value);
            }, fullWidth: true, onKeyPress: function (_a) {
                var key = _a.key;
                return key === "Enter" && createBasket();
            } }), handleClose: close, handleAction: createBasket }));
};
var index = withSuspense(BasketCreate);

export { index as default };
//# sourceMappingURL=index.js.map
